module.exports = __webpack_public_path__ + "static/media/protect-it-sprint.5901cae1.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/protect-it-sprint.jpg
// module id = 1322
// module chunks = 0